import React from "react";
import Layout from "../components/Layout";
import DataTable from "../components/DataTable";

const dt = (v) => (v ? new Date(v).toLocaleString("ko-KR") : "");

export default function Users() {
  return (
    <Layout title="유저 Users">
      <DataTable
        title="Users"
        listPath="/api/admin/users"
        summaryPath="/api/admin/summary/users"
        defaultSort={{ key: "registered_at", order: "desc" }}
        columns={[
          { key: "id", label: "ID", sortable: true },
          { key: "device_uuid", label: "device_uuid", sortable: true },
          { key: "nickname", label: "닉네임", sortable: true },
          { key: "profile_image_index", label: "프로필 #", sortable: false },
          { key: "created_at", label: "created_at", sortable: true, render: dt },
          { key: "registered_at", label: "등록 시각", sortable: true, render: dt },
        ]}
      />
    </Layout>
  );
}
